import './index.css'
import { useContext } from 'react';
import { OpacityContext } from '../utils/opacity';
//fadeDuration atrelado com delay em DelayedLinkWithFadeout, use o mesmo valor para ambos os componentes para ter uma UX consistente
export default function Fade({children, fadeDuration = process.env.REACT_APP_DEFAULT_FADE_TIME, className}) {
    const { visibility } = useContext(OpacityContext)

    return (
    <div 
      className={`mount-fade transition-opacity w-full flex-1 flex flex-col ${visibility.get} self-start ${className}`}
      style={{transitionDuration: `${fadeDuration}ms`}}
    >
      {children}
    </div>
    )
}